/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `none` - NONE
 * * `low` - LOW
 * * `medium` - MEDIUM
 * * `high` - HIGH
 * * `xhigh` - XHIGH
 */
export enum AiThinkingLevel {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  XHIGH = 'xhigh',
}
